export default {
      isEmpty(validation) {
            for (let key in validation)
            {
                  if (validation[key])
                        return false
            }

            return true
      },
      isStringBlank( str ){
            return !str || !str.trim()
      },
      getHttpFieldMessage(response, field, prefix = "") {
            let validation = response && response.fieldErrors && response.fieldErrors[field] && response.fieldErrors[field][0]

            if (!validation) {
                  return null
            }

            if(validation == 'not_exists')
            {
                  validation = "não encontrado" 
            }

            if(validation == 'invalid')
            {
                  validation = "inválido" 
            }


            return prefix + validation
      },
      getHttpMessage(response, prefix) {
            let validation = response && response.errors && response.errors[0]

            if (!validation) {
                  return null
            }

            return prefix + validation
      },
      getMessageError(code)
      {
            if (!code) {
                  return null
            }

            const messageError = {
				max_number_beneficiarios:
					"A quantidade de titulares/dependente enviada de beneficiários excede o limite autorizado. Por favor, acione a sua executiva de conta/vendas para solicitação do ajuste do limite.",
				min_number_beneficiarios: "A quantidade de titulares/dependente enviada de beneficiários está abaixo do limite mínimo autorizado. Por favor, acione a sua executiva de conta/vendas para solicitação do ajuste do limite.",
                        tipo_beneficiario_not_allowed: "O arquivo contém tipo de beneficiário não permitido.",
				file_format_error: "O arquivo não está de acordo com o formato necessário, corrija o arquivo ou baixe a base em branco e preencha.",
			};

            if(Object.prototype.hasOwnProperty.call(messageError, code)) {
                  return messageError[code]
            }

            return "Ocorreu um erro, tente novamente."
      },
      cpfcnpj( cpfcnpj, required ) {

            if (!required && !cpfcnpj)
                  return null

            if ( !cpfcnpj )
                  return "Este campo é obrigatório!"

            cpfcnpj = cpfcnpj.replace(/[^\d]+/g,'')

            if (!validateCNPJ(cpfcnpj) && !validateCPF(cpfcnpj))
                  return "CPF/CNPJ inválido!"

            return ""
      },
      cpf( cpf, required ) {

            if (!required && !cpf)
                  return null

            if ( !cpf )
                  return "Este campo é obrigatório!"

            cpf = cpf.replace(/[^\d]+/g,'')

            if (!validateCPF(cpf))
                  return "CPF inválido!"

            return ""
      },      
      password( password ) {
            if ( !password )
                  return "Este campo é obrigatório"

            let errors = []
            
            if (!password.match(".*\\d.*"))
            {
                  errors.push("um número");
            }
            
            if (!password.match(".*[a-z].*"))
            {
                  errors.push("uma letra minúscula");
            }
            
            if (!password.match(".*[A-Z].*"))
            {
                  errors.push("uma letra maiúscula");
            }
            
            if (!password.match(".*[@#$%^&+=!].*"))
            {
                  errors.push("um caractere especial");
            }
            
            if (password.length < 10)
            {
                  errors.push("no mínimo 10 caracteres");
            }

            if (!errors.length)
                  return ""
            
            // let error = "A senha deve conter pelo menos"

            // error += " " + errors[0]
            
            // if (errors.length > 1) {
            //       for (let i = 1; i < errors.length - 1; i++) {
            //             error += ", " + errors[i]
            //       }

            //       error += " e " + errors[errors.length - 1]
            // }

            return "A senha escolhida não atende os requisitos";
      },
      email( email, required ) {
            
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!required && !email)
                  return null
      
            if( !email )
                  return "Este campo é obrigatório!"
      
            if(re.test(email) == false) 
                  return "E-mail inválido. Por favor, digite um e-mail válido"
            
            return null
      },
      telefone( num, obrigatorio, notValidateRequired ) {
            
            if (!obrigatorio && !num && !notValidateRequired) return null

            const re = /^\([0-9]{2}\) [0-9]?[0-9]{4}-[0-9]{4}$/;

            if (!num && !notValidateRequired) return "Este campo é obrigatório!"

            if (re.test(num) == false) return "Por favor, digite um número válido."

            let onlyDigits = num.replace(/[^0-9]/g, '')

            if (onlyDigits.charAt(0) == "0") return "Não existe DDD que comece com 0."

            if (onlyDigits.charAt(1) == "0") return "Não existe DDD que termine com 0."

            if (onlyDigits.charAt(2) == "0") return "Não existe PABX que comece com 0."

            if (onlyDigits.charAt(2) == "1") return "Não existe PABX que comece com 1."

            return null
      },
      cellPhone(number, obrigatorio, notValidateRequired = false) {
            if (!obrigatorio && !number) return null

            let result = this.telefone(number, obrigatorio, notValidateRequired)

            if (result) {
                  return result
            }

            let cleanedNumber = number.replace(/\D/g, '');
        
            if (cleanedNumber.length > 9) {
                  cleanedNumber = cleanedNumber.substring(cleanedNumber.length - 9)
            }

            return /^(\+?55)?9\d{8}$/.test(cleanedNumber) ? null : "O número deve ser de um celular";
      },
      validateCNPJ (cnpj)
      {
            return validateCNPJ(cnpj)
      },
      validateCPF(cpf)
      {
            return validateCPF(cpf)
      }
}


function validateCNPJ(cnpj) {
 
      cnpj = cnpj.replace(/[^\d]+/g,'')
   
      if(cnpj == '') return false
       
      if (cnpj.length != 14)
          return false
   
      // Elimina CNPJs invalidos conhecidos
      if (cnpj == "00000000000000" || 
          cnpj == "11111111111111" || 
          cnpj == "22222222222222" || 
          cnpj == "33333333333333" || 
          cnpj == "44444444444444" || 
          cnpj == "55555555555555" || 
          cnpj == "66666666666666" || 
          cnpj == "77777777777777" || 
          cnpj == "88888888888888" || 
          cnpj == "99999999999999")
          return false
           
      // Valida DVs
      let length = cnpj.length - 2
      let numbers = cnpj.substring(0, length)
      let digits = cnpj.substring(length)
      let sum = 0
      let pos = length - 7

      for (let i = length; i >= 1; i--) {
        sum += numbers.charAt(length - i) * pos--

        if (pos < 2)
              pos = 9
      }

      let result = sum % 11 < 2 ? 0 : 11 - sum % 11

      if (result != digits.charAt(0))
          return false
           
      length = length + 1
      numbers = cnpj.substring(0, length)
      sum = 0
      pos = length - 7

      for (let i = length; i >= 1; i--) {
        sum += numbers.charAt(length - i) * pos--

        if (pos < 2)
              pos = 9
      }

      result = sum % 11 < 2 ? 0 : 11 - sum % 11

      if (result != digits.charAt(1))
            return false
             
      return true
  }

function validateCPF(cpf) {
      cpf = cpf.replace(/\D/g, '')

      if ( cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf) ) {
            return false
      }

      let result = true

      for (let j = 9; j < 11; j++) {
            let soma = 0, r

            cpf.split(/(?=)/).splice(0,j).forEach(function(e, i) {
                  soma += parseInt(e) * ((j+2)-(i+1))
            });

            r = soma % 11
            r = (r <2) ? 0 : 11 - r

            if (r != cpf.substring(j, j + 1))
            result = false
      }

      return result
}